var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.5C14 6.11929 15.1193 5 16.5 5C17.8807 5 19 6.11929 19 7.5V11H14V7.5Z",
    fill: "#BF3F04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 7.5C30 6.11929 31.1193 5 32.5 5C33.8807 5 35 6.11929 35 7.5V11H30V7.5Z",
    fill: "#BF3F04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36.252C41 38.612 40.9999 39.792 40.5371 40.6943C40.1296 41.4888 39.4774 42.1352 38.6777 42.54C37.7696 42.9996 36.582 43 34.207 43H13.793C11.4178 43 10.2285 42.9997 9.32031 42.54C8.52062 42.1352 7.87035 41.4888 7.46289 40.6943C6.99979 39.7912 7 38.6094 7 36.2451V19.5H41V36.252ZM34.085 24.9639C33.5129 24.3649 32.563 24.3431 31.9639 24.915L21.9316 34.4902L16.96 30.3477C16.3235 29.8175 15.3779 29.9037 14.8477 30.54C14.3175 31.1765 14.4037 32.1221 15.04 32.6523L21.04 37.6523C21.6258 38.1403 22.4847 38.1114 23.0361 37.585L34.0361 27.085C34.6351 26.5129 34.6569 25.563 34.085 24.9639ZM34.2002 9.22266C36.5802 9.22266 37.7686 9.22257 38.6777 9.68262C39.4774 10.0874 40.1296 10.7329 40.5371 11.5273C40.9998 12.4296 41 13.6117 41 15.9717L7 15.9785C7 13.6141 6.99983 12.4305 7.46289 11.5273C7.87035 10.7329 8.52062 10.0874 9.32031 9.68262C10.2294 9.22248 11.4207 9.22266 13.8008 9.22266H34.2002Z",
    fill: "#BF3F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.988012c20fdaa820ec9c2211921001cd.svg";
export { ForwardRef as ReactComponent };